// /teachers DataGrid 컬럼 정의.
// flex 전면 제거 → width + minWidth 고정. enum(권한 / 승인상태)은 StatusChip 매핑으로 표시한다.

import type { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { StatusChip, OverflowTooltip } from "components/list";
import { ITeacher } from "../interfaces";
import { authMeta, approvalMeta, resolveStatusMeta } from "./teachersStatus";

// 수정일 문자열 포맷 (기존 로직 유지)
const formatUpdatedDate = (value: unknown): string => {
  const date = new Date(value as string);
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();

  const formattedHours = hours % 12 === 0 ? 12 : hours % 12;
  const amPm = hours < 12 ? "오전" : "오후";
  const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
  const formattedSeconds = seconds < 10 ? `0${seconds}` : seconds;

  return `${date.getFullYear()}년 ${date.getMonth() + 1}월 ${date.getDate()}일 ${amPm} ${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
};

export const teachersColumns: GridColDef<ITeacher>[] = [
  {
    field: "id",
    headerName: "ID",
    type: "number",
    width: 84,
    minWidth: 72,
    align: "center",
    headerAlign: "center",
  },
  { field: "loginId", headerName: "로그인ID", type: "string", width: 120, minWidth: 100 },
  { field: "name", headerName: "이름", width: 146, minWidth: 115 },
  { field: "nickName", headerName: "닉네임", width: 150, minWidth: 120 },
  {
    field: "auth",
    headerName: "권한",
    type: "string",
    width: 110,
    minWidth: 88,
    align: "center",
    headerAlign: "center",
    renderCell: (params: GridRenderCellParams) => {
      const meta = resolveStatusMeta(authMeta, params.value);
      return <StatusChip label={meta.label} color={meta.color} />;
    },
  },
  { field: "address", headerName: "주소", width: 284, minWidth: 220 },
  {
    field: "location.sido",
    headerName: "시도",
    width: 110,
    minWidth: 90,
    renderCell: (params: GridRenderCellParams) => (
      <OverflowTooltip value={params.row.location?.sido} />
    ),
  },
  {
    field: "location.sigungu",
    headerName: "시군구",
    width: 120,
    minWidth: 100,
    renderCell: (params: GridRenderCellParams) => (
      <OverflowTooltip value={params.row.location?.sigungu} />
    ),
  },
  {
    field: "phoneNumber",
    headerName: "전화번호",
    width: 140,
    minWidth: 120,
    renderCell: (params: GridRenderCellParams) => {
      const formattedPhoneNumber =
        params.value && params.value.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
      return <OverflowTooltip value={formattedPhoneNumber} />;
    },
  },
  {
    field: "centerName",
    headerName: "시설이름",
    width: 198,
    minWidth: 160,
  },
  {
    field: "approval",
    headerName: "승인상태",
    type: "string",
    width: 100,
    minWidth: 88,
    align: "center",
    headerAlign: "center",
    renderCell: (params: GridRenderCellParams) => {
      const meta = resolveStatusMeta(approvalMeta, params.value);
      return <StatusChip label={meta.label} color={meta.color} />;
    },
  },
  {
    field: "updatedDate",
    headerName: "수정일",
    width: 225,
    minWidth: 180,
    renderCell: (params: GridRenderCellParams) => (
      <OverflowTooltip value={formatUpdatedDate(params.value)} />
    ),
  },
];
